(function() {
  'use strict';

  angular
    .module('quiz.labelingItemsInPicture')
    .directive('lipView', LipView);

  LipView.$inject = ['$timeout', 'BoxCaptionPositionCalculator', '$window'];

  function LipView($timeout, BoxCaptionPositionCalculator, $window) {
    return function(scope, element, attrs) {
      scope.view = {
        isDragging: false
      };

      var traineeBoxWidth = 773;
      var traineeBoxHeight = 530;
      var captionHeight = 51;
      var leftOverflowAreaWidth = 14;
      var rightOverflowAreaWidth = 220;
      var rightOverflowAreaTop = 250;
      var captionOverlapWidth = 0;
      var insideBoxOffsetX = 2;
      var captions = [];
      var regions = [];

      function getWidthOfTheLongestRegionLabel() {
        var calculator = $(".lipRegionLabelTextWidthCalculator");
        var longest = 0;
        _.each(captions, function(caption) {
          calculator.text(caption.text);
          var width = calculator.outerWidth();
          if (width > longest) {
            longest = width;
          }
        });
        return longest;
      }

      scope.$watch(attrs.lipViewRegions, function(value) {
        regions = value;
        $timeout(function() {
          setupRegionLabelPositions();
          scope.$broadcast('redraw');
        }, 100);
        drawDragOverlay();
      });

      scope.$watch(attrs.lipViewCaptions, function(value) {
        captions = value;
      });

      function setupRegionLabelPositions() {
        var longestCaptionWidth = getWidthOfTheLongestRegionLabel();
        var containerBoxSize = {
          width: traineeBoxWidth,
          height: traineeBoxHeight
        };

        var leftOverflowRectangle = {
          width: leftOverflowAreaWidth,
          height: traineeBoxHeight,
          y: 0
        };

        var rightOverflowRectangle = {
          width: rightOverflowAreaWidth,
          height: traineeBoxHeight - rightOverflowAreaTop,
          y: rightOverflowAreaTop
        };

        BoxCaptionPositionCalculator.setCaptionPositions(regions,
          longestCaptionWidth, captionHeight, containerBoxSize, leftOverflowRectangle, rightOverflowRectangle, captionOverlapWidth, insideBoxOffsetX);
      }

      function roundRect(ctx, x, y, width, height, radius, fill, stroke) {
        if (typeof stroke == "undefined") {
          stroke = true;
        }
        if (typeof radius === "undefined") {
          radius = 5;
        }
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        if (stroke) {
          ctx.stroke();
        }
        if (fill) {
          ctx.fill();
        }
      }

      function drawDragOverlay() {
        // TODO: No IE8 support for canvas
        if ($window.Modernizr && !Modernizr.canvas)
          return;
        var canvasElement = $(".lipDragOverlay");
        var canvas = canvasElement[0];
        var ctx = canvas.getContext("2d");
        ctx.globalCompositeOperation = "source-over";
        ctx.clearRect(0, 0, scope.traineeBoxWidth, scope.traineeBoxHeight);
        ctx.globalAlpha = 0.5;
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, scope.traineeBoxWidth, scope.traineeBoxHeight);
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "destination-out";
        ctx.fillStyle = "rgba(255, 255, 255, 1)";
        _.each(regions, function(region) {
          roundRect(ctx, region.x + 1, region.y + 1, region.width, region.height, 5, true, false);
        })
      }
    };
  }
})();
